<div class="lg:grid lg:min-h-[60vh] lg:grid-cols-2 lg:items-stretch lg:gap-12 xl:gap-20">
  <!-- Left column -->
  <div class="max-w-xl py-6 lg:py-10">
    <span class="flex h-12 w-12 items-center justify-center rounded-full bg-red-700" aria-hidden="true">
      <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M1 5.917 5.724 10.5 15 1.5" />
      </svg>
    </span>

    <h1 class="mt-6 text-4xl font-extrabold tracking-tight text-gray-900">
      Thanks &mdash; we've got everything we need.
    </h1>

    <p class="mt-4 text-lg text-gray-600">
      We're reviewing the details for {{ venueName || 'your venue' }}. Watch for an invite email
      <ng-container *ngIf="email"> at <span class="font-semibold text-gray-900">{{ email }}</span></ng-container>,
      usually within one business day.
    </p>

    <h2 class="mt-8 text-xs font-semibold uppercase tracking-widest text-gray-500">What setup involves</h2>
    <ol class="mt-4 space-y-5 rounded-2xl border border-stone-200 bg-stone-50 p-6">
      <li class="flex gap-3">
        <span class="font-bold text-red-700">1</span>
        <div>
          <p class="font-bold text-gray-900">Set up your login</p>
          <p class="mt-0.5 text-gray-600">One click from the invite email.</p>
        </div>
      </li>
      <li class="flex gap-3">
        <span class="font-bold text-red-700">2</span>
        <div>
          <p class="font-bold text-gray-900">Build your menu</p>
          <p class="mt-0.5 text-gray-600">Start from a template for your venue type.</p>
        </div>
      </li>
      <li class="flex gap-3">
        <span class="font-bold text-red-700">3</span>
        <div>
          <p class="font-bold text-gray-900">Connect your payout account</p>
          <p class="mt-0.5 text-gray-600">Needed before your first order settles.</p>
        </div>
      </li>
      <li class="flex gap-3">
        <span class="font-bold text-red-700">4</span>
        <div>
          <p class="font-bold text-gray-900">Print your QR signage</p>
          <p class="mt-0.5 text-gray-600">Ready-made posters for your window.</p>
        </div>
      </li>
    </ol>

    <p class="mt-8 text-sm text-gray-500">
      Nothing arrived? Check spam, or
      <a [href]="contactUrl" target="_blank" rel="noopener noreferrer"
        class="font-semibold text-red-700 underline underline-offset-2 hover:text-red-800">contact us</a>.
    </p>
  </div>

  <!-- Right column: photo (desktop only) -->
  <div class="hidden overflow-hidden rounded-2xl lg:block">
    <img
      src="assets/stock/concession1.png"
      alt="Customers ordering at a concession window"
      class="h-full w-full object-cover"
    />
  </div>
</div>
